














































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import DataTable from '@/app/ui/components/DataTable/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'
import Badge from '@/app/ui/components/Badge/index.vue'
import EyeIcon from '@/app/ui/assets/eye_filled.vue'
import FileIcon from '@/app/ui/assets/icon_file.vue'
import DownloadIcon from '@/app/ui/assets/icon_download.vue'
import ImageViewer from '@/app/ui/components/ImageViewer/index.vue'
import Loading from '@/app/ui/components/Loading/index.vue'
import ModalNotes from '../components/Modals/ModalNotes/index.vue'
import ModalUploadBulky from '../components/Modals/ModalUploadBulky/index.vue'
import ModalSuccess from '../components/Modals/ModalSuccess/index.vue'
import ModalFailed from '../components/Modals/ModalFailed/index.vue'
import controller from '@/app/ui/controllers/ManualAdjustmentBalanceController'
import {
  ManualAdjustmentBalance,
  ManualAdjustmentBalanceCourier,
  ManualAdjustmentUploadHistory
} from '@/domain/entities/ManualAdjustmentBalance'
import { EventBus, EventBusConstants, Utils } from '@/app/infrastructures/misc'
import { EnumStatusUpload } from '@/app/ui/controllers/ProductController'
import dayjs from 'dayjs'
import dayjsID from 'dayjs/locale/id'

interface IDateRange {
  start: string
  end: string
  shortcut: string
}

interface IOptions {
  label: string
  value: string | number
}

interface IParams {
  page: number
  per_page: number
  sort: IOptions
  keyword: string
  filter: IOptions
  activity: string
  type: string
  date_range: IDateRange | null
  time_zone: string
}

@Component({
  components: {
    Button,
    TextInput,
    DropdownSelect,
    DataTable,
    PaginationNav,
    Badge,
    EyeIcon,
    FileIcon,
    DownloadIcon,
    DateTimePicker,
    ImageViewer,
    ModalNotes,
    ModalUploadBulky,
    ModalSuccess,
    ModalFailed,
    Loading,
  },
})
export default class ManualAdjustSaldo extends Vue {
  controller = controller
  imageViewerVisible = false
  currentDate = dayjs().locale(dayjsID).format("YYYY-MM-DD")
  modalUploadBulkyVisible = false
  modalSuccessVisible = false
  modalFailedVisible = false
  failedFilepath = ''
  imageUrls: Array<string> = []

  modalNotes = {
    visible: false,
    notes: '',
  }

  typeOptions = [
    { label: 'Rekonsiliasi Penambahan Saldo', value: 'BAL_ADD_RCC' },
    { label: 'Rekonsiliasi Pengurangan Saldo', value: 'BAL_RDC_RCC' },
  ]

  activityOptions = [
    { label: 'Tambah Saldo', value: 'ADD_BAL' },
    { label: 'Tarik Saldo', value: 'RDC_BAL' },
  ]

  filterOptions = [
    { label: 'Semua', value: '' },
    ...this.typeOptions,
    ...this.activityOptions
  ]

  sortOptions = [
    { label: 'Terbaru', value: 'DESC' },
    { label: 'Terlama', value: 'ASC' },
  ]

  customDateShortcuts = [
  { key: 'chooseDate', label: 'Tentukan Tanggal', value: 0 },
  { key: 'last7Days', label: '7 Hari Terakhir', value: 7 },
  { key: 'last14Days', label: '14 Hari Terakhir', value: 14 },
  { key: 'last30Days', label: '30 Hari Terakhir', value: 30 },
  ]

  parameters: IParams = {
    page: 1,
    per_page: 10,
    sort: this.sortOptions[0],
    keyword: '',
    filter: this.filterOptions[0],
    activity: '',
    type: '',
    time_zone: '',
    date_range: null
  }

  historyParameter = {
    page: 1,
    per_page: 5
  }

  headers = [
    'Transaksi ID',
    'Nama Driver',
    'Tipe',
    'Aktivitas',
    'Jumlah',
    'Status',
    'Bukti Transaksi',
    'Catatan',
    'Created By',
    'Created At',
  ]

  perPageOptions: IOptions[] = [
    { label: '10', value: 10 },
    { label: '50', value: 50 },
    { label: '100', value: 100 }
  ]

  manualAdjustList: Array<string | string[] | number> = []

  uploadManualAdjustSaldoList: Array<Array<string>> = []

  created(): void {
    EventBus.$on(EventBusConstants.UPLOAD_BULKY_MANUAL_ADJUSTMENT_BALANCE_SUCCESS, (response: string) => {
      this.modalUploadBulkyVisible = false
      if (response) {
        this.modalFailedVisible = true
        this.failedFilepath = response
      } else {
        this.modalSuccessVisible = true
      }
      this.fetchManualAdjustmentUploadHistory();
    })

    EventBus.$on(EventBusConstants.UPLOAD_BULKY_MANUAL_ADJUSTMENT_BALANCE_FAILED, () => {
      this.modalUploadBulkyVisible = false
    })

    this.parameters.time_zone = dayjs().locale(dayjsID).format('Z');
    this.fetchManualAdjustmentBalance();
    this.fetchManualAdjustmentUploadHistory();
  }

  mounted() {
    this.setDatePickerStyle()
  }

  get params(): Record<string, string | number> {
    let payload: Record<string, string | number> = {
      page: this.parameters.page,
      per_page: this.parameters.per_page,
      sort: this.parameters.sort.value,
      keyword: this.parameters.keyword,
      activity: this.activityOptions.find((opt) => opt === this.parameters.filter)?.value || '',
      type: this.typeOptions.find((opt) => opt === this.parameters.filter)?.value || '',
      time_zone: encodeURIComponent(this.parameters.time_zone)
    }

    if (this.parameters.date_range?.start && this.parameters.date_range?.end) {
      payload.date_from = this.parameters.date_range?.start || ''
      payload.date_to = this.parameters.date_range?.end || ''
    }

    return payload;
  }

  get historyParams(): Record<string, string | number> {
    return {
      page: this.historyParameter.page,
      per_page: this.historyParameter.per_page
    };
  }

  private setDatePickerStyle(): void {
    (this.$el.getElementsByClassName('shortcuts-container')[0] as HTMLDivElement).style.minWidth = '160px'
  }

  private fetchManualAdjustmentBalance(reset?: boolean): void {
    if (reset) this.parameters.page = 1
    controller.getAll(this.params)
  }

  private fetchManualAdjustmentBalancePerPage(val: number): void {
    this.parameters.per_page = val
    this.fetchManualAdjustmentBalance(true)
  }

  private fetchManualAdjustmentUploadHistory(reset?: boolean): void {
    if (reset) this.historyParameter.page = 1
    controller.getListUploadHistory(this.historyParams)
  }

  private onFilterList = Utils.debounce(() => {
    this.fetchManualAdjustmentBalance(true)
  }, 400)

  private onDatepickerFilter(): void {
    if (this.parameters.date_range?.start && !this.parameters.date_range?.end) {
      return
    }

    this.onFilterList()
  }

  private handleModalNotes(visible: boolean, note: string): void {
    this.modalNotes.visible = visible
    this.modalNotes.notes = note
  }

  private onAdd() {
    this.$router.push('/payroll/manual-adjust-saldo/create')
  }

  private onExportExcel() {
    // TEMPORARY FIX FOR EXPORT EXCEL
    window.open('https://metabase.thelionparcel.com/question/1790-prd-manual-adjusment', '_blank')

    // TODO: NEED ADJUSTMENT LATER FOR EXPORT EXCEL
    // let exportParams: Record<string, string | number> = {
    //   sort: this.params.sort,
    //   keyword: this.params.keyword,
    //   activity: this.params.activity,
    //   type: this.params.type,
    //   time_zone: this.params.time_zone
    // }
    //
    // if (this.params.date_from) {
    //   exportParams.date_from = this.params.date_from || ''
    // }
    //
    // if (this.params.date_to) {
    //   exportParams.date_to = this.params.date_to || ''
    // }
    //
    // controller.exportManualAdjustmentBalance(exportParams)
  }

  private onDownloadTemplate(): void {
    controller.downloadTemplate()
  }

  private onCloseModalNotifUpload(): void {
    this.modalSuccessVisible = false
    this.modalFailedVisible = false
    controller.setFilenameBulkUpload('')
  }

  private onDownloadFailedBulkUploadData(): void {
    window.open(process.env.VUE_APP_STORAGE_BASE_URL+'/'+this.failedFilepath)
  }

  private onClickDownloadData(filepath: string): void {
    window.open(process.env.VUE_APP_STORAGE_BASE_URL+'/'+filepath)
  }

  private onHandleImageViewer(visible: boolean, urls: Array<string>): void {
    if (urls) {
      if (urls.length !== 0) {
        this.imageUrls = urls.map((url) => process.env.VUE_APP_STORAGE_BASE_URL+'/'+url)
      } else if (urls.length === 0) {
        this.imageUrls = []
      }
    }
    this.imageViewerVisible = visible
  }

  private formatTypeLabel(type?: string): string | undefined {
    const res = this.typeOptions.find((t) => type === t.value)
    return res?.label
  }

  private formatActivityValue(activity?: string): string | undefined {
    const res = this.activityOptions.find((a) => activity === a.value)
    return res?.label
  }

  private formatName(courier?: ManualAdjustmentBalanceCourier): string {
    if (courier) {
      return `[${courier?.id}] ${courier?.fullname} ${courier?.phoneNumber}`
    }
    return ''
  }

  private formatAmount(amount?: number): string | undefined{
    if (!amount) {
      return '-'
    }

    if (amount < 0) {
      return `-Rp${amount * -1}`
    } else if (amount >= 0) {
      return `Rp${amount}`
    }
  }

  private formatUploadHistoryDate(date: Date): string {
    const formattedDateTime = dayjs(date).locale(dayjsID).format('DD MMM YYYY, HH:mm Z')

    if (formattedDateTime.includes('+07:00')) return formattedDateTime.replace('+07:00', 'WIB')
    if (formattedDateTime.includes('+08:00')) return formattedDateTime.replace('+08:00', 'WITA')
    if (formattedDateTime.includes('+09:00')) return formattedDateTime.replace('+09:00', 'WIT')

    return formattedDateTime
  }

  @Watch('controller.dataPayrollManualAdjustmentList')
  setDataPayrollManualAdjustmentList(data: ManualAdjustmentBalance[]): void {
    const result = data.map((list: ManualAdjustmentBalance) => {
      return [
        list.id,
        this.formatName(list.courier),
        this.formatTypeLabel(list.type),
        this.formatActivityValue(list.activity),
        this.formatAmount(list.amount),
        list.status,
        list.meta,
        list.notes,
        list.createdBy,
        dayjs(list.createdAt).locale(dayjsID).format('dddd, DD MMM YYYY, HH:mm:ss'),
      ]
    })

    this.manualAdjustList = result as Array<string | string[] | number>
  }

  @Watch('controller.dataManualAdjustmentUploadHistoryList')
  setDataManualAdjustmentUploadHistoryList(data: ManualAdjustmentUploadHistory[]): void {
    const result = data.map((list: ManualAdjustmentUploadHistory) => {
      return [
        list.createdAt ? this.formatUploadHistoryDate(list.createdAt) : '',
        list.filename,
        list.statusId,
        list.filepath
      ]
    })

    this.uploadManualAdjustSaldoList = result as Array<Array<string>>
  }

  @Watch('controller.statusUpload')
  refreshManualAdjustmentList(data: EnumStatusUpload) {
    if (data === EnumStatusUpload.COMPLETE) {
      this.fetchManualAdjustmentBalance()
    }
  }
}
